<div class="page-layout simple full-width">

    <!-- HEADER -->
    <div class="header p-24 pb-0" fxLayout="row" fxLayoutAlign="space-between center">

        <div fxLayout="column" fxLayoutAlign="center start" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
            <div class="h2 mt-5"> Transacciones </div>
        </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content">

        <!-- CENTER -->
        <div class="center p-24 pb-56" fusePerfectScrollbar>



            <!-- CONTENT -->
            <div class="content">

                <div class="container-filters" fxLayout="row" fxLayoutGap="24px" fxLayoutGap.xs="16px">

                    <!--<div class="" fxFlex="30%">
                        <mat-form-field appearance="outline" fxFlex="80%" fxFlex.lt-md="40%" class="pl-4">
                            <mat-label>Buscar...</mat-label>
                            <input matInput name="search" [(ngModel)]="filterSearch" (keydown.enter)="onSearch()" />
                        </mat-form-field>
    
                        <button class="ml-4 btn-icon-search" mat-raised-button color="primary" (click)="onSearch()"><mat-icon aria-hidden="false" aria-label="Buscar">search</mat-icon></button>
                    </div>-->
                    <mat-form-field appearance="outline" fxFlex.xs="calc(100% - 150px)" fxFlex.lt-md="40%" class="pl-4">
                        <mat-label>Id</mat-label>
                        <input matInput  name="search-id" [(ngModel)]="filterSearchId" (keydown.enter)="onFilters()" />
                    </mat-form-field>

                    <div fxFlex="20%" fxFlex.xs="50%">
                        <mat-form-field appearance="outline" fxFlex="100%">
                            <mat-label>Seleccionar fecha</mat-label>
                            <input matInput [matDatepicker]="picker" [(ngModel)]="filterDate" (dateChange)="onFilters()">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                          </mat-form-field>
                    </div>

                    <div fxFlex="20%" fxFlex.xs="50%">
                        <mat-form-field  appearance="outline" fxFlex="100%">
                            <mat-label>Estado:</mat-label>
                            <mat-select [(ngModel)]="filterStatus" (selectionChange)="onFilters()">
                                <mat-option [value]="-1">Todos</mat-option>
                                <mat-option [value]="0">Pendiente</mat-option>
                                <mat-option [value]="1">Pagado</mat-option>
                                <mat-option [value]="2">Cancelado</mat-option>
                                <mat-option [value]="3">Devuelto</mat-option>
                                <mat-option [value]="4">Pagado Confirmado</mat-option>
                                <mat-option [value]="5">Envio pendiente</mat-option>
                                <mat-option [value]="6">Entregado</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline"  fxFlex.xs="calc(100% - 70px)" fxFlex.lt-md="40%" class="pl-4">
                            <mat-label>Nombre</mat-label>
                            <input matInput  name="search-nombre" [(ngModel)]="filterSearchNombre" (keydown.enter)="onFilters()" />
                        </mat-form-field>

                        <mat-form-field appearance="outline" fxFlex.xs="calc(100% - 70px)" fxFlex.lt-md="40%" class="pl-4">
                            <mat-label>Apellido</mat-label>
                            <input matInput  name="search-apellido" [(ngModel)]="filterSearchApellido" (keydown.enter)="onFilters()" />
                        </mat-form-field>
                        <mat-form-field appearance="outline" fxFlex.xs="calc(100% - 70px)" fxFlex.lt-md="40%" class="pl-4">
                            <mat-label>Nro Asociado</mat-label>
                            <input matInput  name="search-nroasociado" [(ngModel)]="filterSearchExternalCode" (keydown.enter)="onFilters()" />
                        </mat-form-field>
                    </div>

                </div>

                <div class="container-table transaction-table">
                    <mat-table #table [dataSource]="dataItems.data" [@animateStagger]="{value:'50'}" >

                        <ng-container *ngFor="let column of configColumns" [matColumnDef]="column.key">
                            <!-- TH -->
                            <mat-header-cell *matHeaderCellDef>{{ column.title }}</mat-header-cell>

                            <!-- TD -->
                            <mat-cell *matCellDef="let item">

                                <ng-container *ngIf="column.type == 'integer' || column.type == 'string'">
                                    <p [ngClass]="{'text-truncate': column.type == 'integer'}" class="{{ column.classes }}">{{ item[column.field_key] }}</p>
                                </ng-container>

                                <ng-container *ngIf="column.type == 'money'">
                                    <p class="{{ column.classes }}">{{ item[column.field_key] | currency }}</p>
                                </ng-container>

                                <ng-container *ngIf="column.type == 'option'">
                                    <p class="{{ column.classes }}">{{ column.options[item[column.field_key]].title }}</p>
                                </ng-container>

                            </mat-cell>
                            
                            
                        </ng-container>

                        <ng-container [matColumnDef]="'code'">
                            <!-- TH -->
                            <mat-header-cell *matHeaderCellDef>Cod.</mat-header-cell>
                            <!-- TD -->
                            <mat-cell *matCellDef="let item">

                                <ng-container>
                                    <p *ngIf="item.user" class="">{{ item.user.external_code }}</p>
                                </ng-container>

                            </mat-cell>
                        </ng-container>

                        <ng-container [matColumnDef]="'document'">
                            <!-- TH -->
                            <mat-header-cell *matHeaderCellDef>Doc..</mat-header-cell>
                            <!-- TD -->
                            <mat-cell *matCellDef="let item">

                                <ng-container>
                                    <p *ngIf="item.user" class="">{{ item.user.document }}</p>
                                </ng-container>

                            </mat-cell>
                        </ng-container>

                        <ng-container [matColumnDef]="'user'">
                            <!-- TH -->
                            <mat-header-cell *matHeaderCellDef>Usuario</mat-header-cell>
                            <!-- TD -->
                            <mat-cell *matCellDef="let item">

                                <ng-container>
                                    <p *ngIf="item.user" class="">{{ item.user.firstname }} {{ item.user.lastname }}</p>
                                </ng-container>

                            </mat-cell>
                        </ng-container>

                        <ng-container [matColumnDef]="'email'">
                            <!-- TH -->
                            <mat-header-cell *matHeaderCellDef>Email</mat-header-cell>
                            <!-- TD -->
                            <mat-cell *matCellDef="let item">

                                <ng-container>
                                    <p *ngIf="item.user" class="">{{ item.user.email }}</p>
                                </ng-container>

                            </mat-cell>
                        </ng-container>

                        <ng-container [matColumnDef]="'category'">
                            <!-- TH -->
                            <mat-header-cell *matHeaderCellDef>Categoría</mat-header-cell>

                            <!-- TD -->
                            <mat-cell *matCellDef="let item">

                                <ng-container>
                                    <p class="">{{ item.category.title }}</p>
                                </ng-container>

                            </mat-cell>
                            
                            
                        </ng-container>
                        

                        <!-- Buttons Column -->
                        <ng-container matColumnDef="actions" stickyEnd>
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let item">
                                <div fxFlex="row" fxLayoutAlign="end center">

                                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="Acciones" (click)="$event.stopPropagation();">
                                        <mat-icon class="secondary-text">more_vert</mat-icon>
                                    </button>

                                    <mat-menu #moreMenu="matMenu">
                                        <button [routerLink]="'/transaction-view/' + item.id" mat-menu-item aria-label="edit">
                                                <mat-icon>edit</mat-icon>
                                                <span>Ver</span>
                                            </button>
                                        <button mat-menu-item aria-label="remove" [swal]="{ title: 'Eliminar ' + item.id, text: '¿Se encuentra seguro de eliminar?', type: 'warning', focusCancel: true, showCancelButton: true, confirmButtonText: 'Eliminar', cancelButtonText: 'Cancelar' }"
                                            (confirm)="onRemove(item)">
                                                <mat-icon>delete</mat-icon>
                                                <span>Eliminar</span>
                                            </button>
                                    </mat-menu>
                                </div>

                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                        <mat-row *matRowDef="let item; columns: displayedColumns;" class="item" (click)="openItem(item)" matRipple [@animate]="{value:'*',params:{y:'100%'}}">
                        </mat-row>
                    </mat-table>
                </div>


                <mat-card *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center">
                    <mat-progress-spinner color="primary" mode="indeterminate">
                    </mat-progress-spinner>
                </mat-card>

                <mat-paginator [length]="dataItems.total" [pageSize]="tableModel.itemPerPage" [pageSizeOptions]="[5, 10, 25, 100]" (page)="onPageChange($event)"></mat-paginator>

            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CENTER -->

    </div>
    <!-- / CONTENT-->

</div>